import styles from "./Label.scss";

const labelClass = styles['au-label'];
const fieldsetClass = styles['au-fieldset'];
const errorClass = styles['au-error-text'];

export const autoFocus = (container: string): void => {
    let label = document.querySelector(`${container} .${labelClass}, ${container} .${fieldsetClass}`) as HTMLLabelElement | null;
    if(!label) {
        return;
    }
    let input:HTMLInputElement | null;
    if(label.className.indexOf(labelClass) >= 0)
    {
        if(label.htmlFor) {
             input = document.querySelector(`${container} #${label.htmlFor}`) as HTMLInputElement | null;
        }
        else {
            input = null;
        }
    }
    else {
         input = label.querySelector("input") as HTMLInputElement | null;
    }
    if(input && input.focus) {
        input.focus();
    }
}

export const validationFocus = (container: string) => {
    let errorText = document.querySelector(`${container} .${errorClass}`) as HTMLLabelElement | null;
    if(!errorText) {
        return;
    }
    let input:HTMLInputElement | null;
    
    let label = errorText.parentElement as HTMLLabelElement | null;
    if(label && label.className.indexOf(fieldsetClass) >= 0) {
        input = label.querySelector("input") as HTMLInputElement | null;
    }
    else {
        label = errorText.previousElementSibling as HTMLLabelElement | null;
        if(label && label.className.indexOf(labelClass) >= 0) {
            if(label.htmlFor) {
                input = document.querySelector(`${container} #${label.htmlFor}`) as HTMLInputElement | null;
            }
            else {
                input = null;
            }
        }
        else {
            input = null;
        }
    }
    
    if(input && input.focus) {
        input.focus();
    }
}